
import propostaService from "../../services/propostaService";
export default {
  data () {
    return {
      proposta: null,
      contratoControper: {
        nomeCliente: null,
        cpfCnpjCliente: null,
        numeroContrato: null,
        valorContrato: null
      },
      isLoading: false,
      isLoadingRecusar: false,
      isLoadingAceitar: false
    }
  },
  props: ['propostaResponse'],
  components: {
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.proposta = this.propostaResponse.data
      this.contratoControper.nomeCliente = this.propostaResponse.data.nomeCliente
      this.contratoControper.cpfCnpjCliente = this.$b.fCpfCnpj(this.propostaResponse.data.cpfCnpjCliente)
      this.contratoControper.numeroContrato = this.propostaResponse.data.numeroContrato
      this.contratoControper.valorContrato = this.$b.fCurrency(this.propostaResponse.data.valorContrato)
    },
    aceitar () {
      this.isLoadingAceitar = true
      propostaService.aceitaProposta(this.proposta, this.proposta.chave).then(res => {
        if (res.data.code === 99) {
          this.$b.nError(`${res.data.message}`)
          return
        }
        this.$router.push({ name: 'propostaAmzSucesso', params: { mensagemResponse: res.data.message } })
      }).catch(err => {
        this.$b.nError(`${err.data.message}`)
      }).finally(() => {
        this.isLoading = false
        this.isLoadingAceitar = false
      })
    },
    recusar () {
      this.isLoadingRecusar = true
      propostaService.recusarProposta(this.proposta, this.proposta.chave).then(res => {
        if (res.data.code === 99) {
          this.$b.nError(`${res.data.message}`)
          return
        }
        this.$router.push({ name: 'propostaRecusada' })
      }).catch(err => {
        this.$b.nError(`${err.data.message}`)
      }).finally(() => {
        this.isLoading = false
        this.isLoadingRecusar = false
      })
    }
  }
}
